export default () => ({
    perspectiveY: 0,

    init() {
        this.onScroll(); // Initial check on load
    },

    onScroll() {
        const parentOffsetTop = this.$el.offsetTop;
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        this.perspectiveY = scrollY + windowHeight - parentOffsetTop;
    },
});
